
const SIDEBAR_ITEM_CLS = "swivu-editor-sidebar-item text-[#616161] dark:text-[#e6e6e6] bg-transparent border-none w-full py-2 px-3 justify-start rounded-md font-medium gap-[1em] [&_label]:!ml-0 [&_label]:max-w-[`98px`]";

export const SwivuModernEditorMixin = (base) =>
  class extends base {
    static get $name() {
      return "SwivuModernEditorMixin";
    }

    static get configurable() {
      return {
        ...super.configurable,
        cls: "swivu-modern-editor",
        layoutStyle: {
          flexDirection: "row",
          flexWrap: "nowrap",
          alignItems: "stretch",
        },
        items: {
          swivuEditorSidebarContainer: {
            type: "container",
            cls: "w-[var(--editor-sidebar-width)] flex-shrink-0 bg-[var(--editor-sidebar-bg-color)] border-0 border-r border-[var(--editor-border-color)] border-solid flex-shrink-0 p-[1em] pb-0 gap-[1em]",
            layoutStyle: {
              flexDirection: "column",
              flexWrap: "nowrap"
            },
            items: {
              sidebarList: {
                type: "container",
                cls: "space-y-[.5em]",
              },
              swivuAssistButton: {
                type: "button",
                icon: "fa-regular fa-question",
                text: "Swivu Assist",
                cls: "swivu-modern-button secondary mt-auto",
                listeners: {
                  click: "up.onSwivuAssistButtonClick"
                }
              }
            }
          },
          swivuEditorMainContainer: {
            type: "container",
            cls: "w-auto flex-1 gap-0",
            layoutStyle: {
              flexDirection: "column",
              flexWrap: "nowrap"
            },
            items: {
              swivuEditorHeaderContainer: {
                type: "container",
                scrollable: false,
                cls: "flex-shrink-0"
              },
              swivuTabContainer: {
                type: "container",
                cls: "flex-1 [&>.b-panel]:h-full",
              },
              swivuFooterContainer: {
                type: "container",
                cls: "swivu-modern-footer-container",
                scrollable: false
              }
            }
          }
        }
      };
    }

    updateEditorTitle(title, record) {
      if (title || record.name) {
        this.title = `<div class="flex flex-col whitespace-nowrap gap-1 h-full text-left">
          <span class="text-swivu-lg overflow-hidden text-ellipsis font-semibold">
            ${title || record.name || "N/A"}
          </span>
        </div>`;
      } else {
        this.title = `<div class='text-left text-[1.5em] overflow-hidden text-ellipsis font-semibold'>${this.config.title || "New Record"}</div>`;
      }

      this.updateHeaderLayout();
    }

    initializeModernEditor() {
      this.updateTabsLayout();
      this.updateHeaderLayout();
      this.updateFooterLayout();
      this.updateSidebarLayout();
    }

    updateTabsLayout() {
      const { tabBar, tabs, swivuTabContainer } = this.widgetMap;
      tabBar.hidden = true;
      swivuTabContainer.add(tabs);
    }

    updateHeaderLayout() {
      const { swivuEditorHeaderContainer } = this.widgetMap;
      swivuEditorHeaderContainer.element.append(this.headerElement);
    }

    updateFooterLayout() {
      const { swivuFooterContainer } = this.widgetMap;
      swivuFooterContainer.element.append(this.bbar.element);
    }

    updateSidebarLayout() {
      const { sidebarList, tabBar } = this.widgetMap;
      tabBar.items.forEach((tab) => {
        tab.cls = `${SIDEBAR_ITEM_CLS} ${tab.cls}`;
        sidebarList.element.append(tab.element)
      });
    }
  };
